import { IconButton, Stack, useTheme } from "@mui/material";
import { Camera, Image as ImageIcon, Paperclip } from "lucide-react";
import { type FC, useRef } from "react";
import { ChatComposerInput } from "web_myplann/Chat/Components/ChatComposerInput";
import { ChatComposerSendButton } from "web_myplann/Chat/Components/ChatComposerSendButton";

type Props = {
	value: string;
	onChange: (value: string) => void;
	onSend: () => void;
	onPickPhoto: () => void;
	onPickGallery: () => void;
	onPickFile: () => void;
};

const ICON_BUTTON_SIZE = { width: 36, height: 36 };

export const ChatComposer: FC<Props> = ({
	value,
	onChange,
	onSend,
	onPickPhoto,
	onPickGallery,
	onPickFile,
}) => {
	const theme = useTheme();
	const inputRef = useRef<HTMLTextAreaElement>(null);
	const canSend = value.trim().length > 0;

	const handleSend = () => {
		onSend();
		inputRef.current?.focus();
	};

	return (
		<Stack
			direction="row"
			alignItems="flex-end"
			gap={0.6}
			flexShrink={0}
			px={0.8}
			pt={0.8}
			bgcolor={theme.palette.background.paper}
			pb="max(8px, env(safe-area-inset-bottom, 8px))"
		>
			<IconButton variant="ghost" onClick={onPickPhoto} sx={ICON_BUTTON_SIZE}>
				<Camera size={theme.iconSize.md} color={theme.palette.blue[500]} />
			</IconButton>
			<IconButton variant="ghost" onClick={onPickGallery} sx={ICON_BUTTON_SIZE}>
				<ImageIcon size={theme.iconSize.md} color={theme.palette.blue[500]} />
			</IconButton>
			<IconButton variant="ghost" onClick={onPickFile} sx={ICON_BUTTON_SIZE}>
				<Paperclip size={theme.iconSize.md} color={theme.palette.blue[500]} />
			</IconButton>

			<ChatComposerInput
				inputRef={inputRef}
				value={value}
				onChange={onChange}
				onSubmit={onSend}
			/>

			<ChatComposerSendButton onClick={handleSend} active={canSend} />
		</Stack>
	);
};
